import { injector } from '@maternity/ng-mun-linear';

import { IState } from './types';

export const goto: IState['goto'] = (state: any, params?: any) => {
  const $state = injector.get('$state') as IState;
  return $state.goto(state, params);
};
